function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m202.177 295.243c-.475.949.095 1.377 2.184 1.566l2.374.237 28.008 56.253 28.055 56.205 3.845-7.311c2.088-4.035 6.076-11.867 8.829-17.326 2.753-5.507 6.266-12.391 7.833-15.381l2.848-5.459 11.345 22.738 11.393 22.69 7.121-13.956c3.939-7.69 9.115-17.849 11.535-22.644 2.422-4.794 4.463-8.64 4.51-8.544.381.379 20.65 42.771 20.65 43.15 0 .237-.76.427-1.662.427-1.33 0-1.662.19-1.662.95 0 .949.332.949 13.529.949 13.102 0 13.529-.048 13.529-.902 0-.807-.379-.949-2.469-1.092l-2.516-.143-28.055-56.252-28.055-56.253-10.35 20.745-10.396 20.696.902 1.994c.475 1.044 1.044 2.041 1.234 2.184.237.143 3.085-5.127 6.361-11.726 3.322-6.551 6.123-11.819 6.219-11.678.379.38 13.861 28.245 14.193 29.337.285.854-.094.902-11.346.902-12.438 0-12.295-.048-11.012 2.278l.568 1.092h11.631c6.361-.047 11.82.095 12.105.285.521.38 1.613 2.23 1.613 2.706 0 .142-5.363.284-11.867.284h-11.867l.617 1.52.617 1.566 12.342.237c11.914.237 12.295.285 12.295 1.187 0 1.377-14.004 28.91-14.479 28.435-.949-1.044-43.198-89.529-42.914-89.956.142-.285.949-.428 1.756-.332 1.187.095 1.519-.048 1.519-.713 0-.427-.143-.807-.333-.807-.237 0-6.266 0-13.434 0-11.298 0-13.054.095-13.054.712 0 .522.522.712 1.851.712 1.044 0 2.184.096 2.516.237.38.143 7.5 14.194 15.808 31.141l15.143 30.903-7.168 14.004c-3.893 7.69-7.311 13.957-7.5 13.957-.57 0-43.483-89.34-43.151-89.862.19-.237.902-.38 1.662-.284 1.092.189 1.377.047 1.377-.617 0-.808-.854-.902-13.292-.997-7.306-.091-13.335-.091-13.335-.044zm18.419 1.946c.332.237 10.965 21.505 23.593 47.281l23.023 46.9-.807 1.614c-.379.901-.854 1.614-.997 1.614-.522 0-47.565-96.84-47.281-97.315.332-.568 1.662-.615 2.469-.094zm46.046 0c.332.19 10.871 21.362 23.403 47.044 16.187 32.944 22.787 46.948 22.595 47.66-.143.569-.521 1.424-.854 1.898-.57.712-3.514-5.079-24.258-47.471-12.959-26.583-23.593-48.609-23.593-48.941.001-.617 1.805-.759 2.707-.19zm74.908 57.82c13.861 28.34 25.207 51.838 25.303 52.218.141.475-.285.664-1.426.664h-1.613l-24.732-50.604-24.779-50.556.76-1.662c.428-.901.902-1.613 1.045-1.613.142.047 11.628 23.213 25.442 51.553z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m349.146 295.291c-.096.095-.047.475.094.854.191.522 1.426.664 5.555.664 2.943 0 5.459.143 5.648.285.143.143-4.225 9.352-9.777 20.412l-10.018 20.08 1.045 2.231c.617 1.187 1.234 2.041 1.424 1.898.189-.189 5.365-10.301 11.488-22.501l11.156-22.169 5.125-.142c4.51-.096 5.412-.333 4.984-1.282-.14-.283-26.439-.568-26.724-.33z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m75.953 477.055c-5.269 11.963-9.731 22.026-9.826 22.358-.19.475.332.57 2.278.475l2.516-.142 1.519-3.561c.854-1.946 1.756-3.846 2.089-4.178.38-.427 3.275-.569 11.345-.569 8.118 0 10.966.143 11.298.569.237.332 1.187 2.278 2.041 4.272l1.614 3.703h2.326c2.136 0 2.326-.096 2.089-.95-.427-1.661-19.083-43.625-19.368-43.673-.142.002-4.604 9.781-9.921 21.696zm14.858-.332 4.51 10.681-9.257.143c-5.127.047-9.399.047-9.494-.095-.095-.096 1.899-5.127 4.415-11.156 2.563-6.028 4.794-10.823 4.984-10.586.19.19 2.374 5.127 4.842 11.013z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m208.158 455.836c-5.079 1.045-9.257 3.371-12.722 7.073-4.177 4.463-5.744 9.02-5.459 16.093.143 4.51.332 5.459 1.662 8.308 2.801 5.886 8.26 10.443 14.811 12.39 3.418.997 10.443.997 13.861 0 6.551-1.898 12.01-6.504 14.811-12.39 1.472-3.134 1.519-3.418 1.519-9.447 0-6.171 0-6.171-1.756-9.731-1.946-3.893-5.174-7.405-8.972-9.589-4.415-2.612-12.391-3.799-17.755-2.707zm10.444 4.557c9.352 2.421 14.716 10.538 13.435 20.365-.807 5.934-4.747 11.393-10.017 13.766-9.826 4.463-20.982.665-25.634-8.734-1.424-2.896-1.519-3.418-1.519-8.117 0-4.415.142-5.316 1.234-7.643 1.709-3.608 4.083-6.171 7.548-7.976 4.557-2.42 9.826-3.038 14.953-1.661z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m348.718 456.833c-.379.902-4.652 10.539-9.494 21.457-4.795 10.918-8.924 20.27-9.066 20.792-.285.902-.143.949 2.137.807l2.42-.142 1.662-3.751c.902-2.088 1.898-3.987 2.23-4.177.76-.475 21.268-.475 22.027 0 .332.189 1.328 2.089 2.23 4.177l1.662 3.751 2.467.142c2.186.143 2.422.048 2.232-.712-.428-1.424-18.941-43.056-19.416-43.53-.235-.286-.663.189-1.091 1.186zm6.076 20.365 4.463 10.443h-9.637-9.684l1.852-4.178c.996-2.278 3.133-7.31 4.746-11.203 2.23-5.269 3.086-6.835 3.418-6.313.239.428 2.423 5.507 4.842 11.251z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m380.761 456.026c-4.225 1.378-7.168 5.602-7.168 10.254 0 5.126 2.658 8.497 10.111 12.864 7.168 4.225 8.924 6.599 8.26 11.393-.332 2.658-1.52 4.178-4.035 5.318-1.994.854-2.564.901-5.223.427-1.709-.285-3.844-1.044-4.889-1.709-.996-.665-1.994-1.234-2.23-1.234-.76 0-2.611 2.326-2.326 2.991.143.332 1.566 1.328 3.227 2.23 3.799 1.994 8.83 2.517 12.676 1.234 6.313-2.136 9.447-9.589 6.551-15.713-1.377-2.99-4.414-5.696-9.732-8.782-2.23-1.281-4.842-3.085-5.742-4.034-1.568-1.614-1.662-1.899-1.662-4.984 0-3.038.094-3.418 1.471-4.748 2.611-2.61 7.217-2.706 10.871-.189 2.09 1.425 2.184 1.425 3.561-.047 1.471-1.568.996-2.422-2.422-4.178-3.182-1.615-8.119-2.09-11.299-1.093z"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m445.416 456.026c-9.066 2.231-15.949 9.589-17.184 18.561-1.662 11.678 4.984 21.694 16.52 25.112 3.322.949 9.922.997 13.576.048 10.207-2.659 16.852-11.299 16.852-21.837 0-6.741-2.373-12.247-7.072-16.52-5.603-4.984-15.001-7.215-22.692-5.364zm13.767 5.032c3.797 1.424 7.832 5.269 9.635 9.114 1.234 2.706 1.377 3.465 1.377 7.975 0 5.554-.76 7.833-3.654 11.488-3.893 4.985-11.535 7.69-18.086 6.503-10.111-1.804-17.09-11.346-15.523-21.219 1.234-7.501 6.598-13.292 13.814-14.812 3.226-.663 9.351-.188 12.437.951z"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m562.382 455.694c-.568.901-19.32 43.53-19.32 43.91 0 .189 1.045.38 2.279.38h2.279l1.945-4.272 1.947-4.272h10.869c5.936 0 11.063.189 11.395.38.332.189 1.281 2.041 2.184 4.13l1.613 3.798 2.422.142c1.375.096 2.467 0 2.467-.189 0-.475-19.082-43.53-19.463-44.005-.189-.239-.474-.239-.617-.002zm5.366 21.172c2.42 5.696 4.271 10.443 4.178 10.586-.143.095-4.416.142-9.494.095l-9.258-.143 3.941-9.257c2.184-5.079 4.318-10.111 4.746-11.155.57-1.425.855-1.709 1.139-1.187.191.379 2.326 5.364 4.748 11.061z"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m580.517 456.69c-2.754 2.469-1.613 6.931 2.041 7.881 3.514.901 6.551-1.234 6.551-4.558 0-4.272-5.27-6.313-8.592-3.323zm6.693.95c2.137 2.705.332 6.266-3.229 6.266-2.848 0-4.746-2.516-3.844-5.127.997-2.895 5.175-3.56 7.073-1.139z"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m6.313 456.643c.143.237 4.13 9.778 8.877 21.267s8.925 21.361 9.209 21.979c.522.997 1.092-.142 6.456-12.437 3.275-7.452 6.076-13.386 6.266-13.197.142.19 2.706 5.791 5.602 12.438 2.943 6.646 5.602 12.579 5.886 13.196.522.997 1.424-.949 9.684-20.887 5.032-12.104 9.114-22.121 9.114-22.358 0-.19-1.044-.331-2.326-.331h-2.326l-2.563 6.265c-1.424 3.466-4.462 11.061-6.835 16.853-2.326 5.839-4.32 10.586-4.462 10.586s-2.801-5.792-5.886-12.817c-3.085-7.073-5.792-12.96-5.981-13.055-.19-.095-2.848 5.649-5.934 12.817-3.085 7.168-5.744 13.055-5.886 13.055-.143 0-3.371-7.596-7.121-16.853l-6.836-16.851h-2.564c-1.424-.002-2.468.14-2.374.33z"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m113.882 456.501c-.095.095-.143 9.921-.047 21.837l.095 21.646h11.44 11.393l-.143-1.946-.143-1.899-9.019-.095-9.02-.095-.143-19.843-.095-19.794h-2.042c-1.137-.001-2.181.094-2.276.189z"
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m144.785 478.195v21.931l8.687-.284c6.124-.19 9.399-.475 11.25-1.045 10.301-3.18 16.14-10.822 16.14-21.124 0-8.688-4.272-15.427-12.105-18.988-4.272-1.946-7.073-2.372-15.903-2.372h-8.07v21.882zm20.935-16.33c4.225 1.946 6.741 4.367 8.592 8.117 1.472 2.943 1.567 3.513 1.567 7.928 0 4.13-.143 5.079-1.282 7.453-3.418 7.357-10.159 10.823-21.077 10.823-3.133 0-3.94-.143-4.177-.76-.427-1.092-.333-34.606.095-35.033.19-.237 3.228-.285 6.741-.189 5.98.141 6.597.284 9.541 1.661z"
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m247.796 478.147v21.837h2.374 2.374v-19.938-19.938h5.364c6.266 0 8.308.475 10.586 2.469 2.136 1.898 3.038 3.655 3.038 6.028 0 2.422-.712 4.226-2.278 5.887-2.326 2.469-3.703 2.896-9.969 3.181l-5.839.237 10.063 11.014 10.111 11.061h2.516c1.377 0 2.516-.143 2.516-.38 0-.19-3.845-4.51-8.544-9.589l-8.545-9.257 3.323-.285c6.931-.665 11.393-5.459 11.393-12.152-.047-5.032-3.038-9.209-7.928-11.06-2.231-.809-3.703-.949-11.535-.949h-9.02z"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m288.146 478.147v21.837h2.136 2.136v-9.494-9.494h7.88 7.832l-.143-1.946-.141-1.946-6.932.047c-3.797.048-7.263-.047-7.69-.237-.712-.237-.807-1.234-.807-8.545v-8.26h10.206 10.207v-1.898-1.897h-12.344-12.342v21.833z"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m404.923 458.21v1.852l4.891.143 4.842.142.143 19.796.094 19.843h2.137 2.137v-19.938-19.938h4.984 4.984v-1.898-1.897h-12.105-12.105v1.895z"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m486.097 478.147v21.837h2.137 2.137l.096-19.843.141-19.796 4.748-.142c6.029-.19 9.256.475 11.488 2.421 2.895 2.563 3.703 5.791 2.277 9.257-1.852 4.367-4.035 5.459-11.629 5.791l-5.887.237 10.111 11.014 10.158 11.061h2.516c1.424 0 2.564-.143 2.564-.38 0-.19-3.893-4.51-8.641-9.589l-8.592-9.257 3.039-.285c3.844-.332 5.98-1.282 8.26-3.513 6.219-6.267 3.939-16.615-4.416-19.7-2.184-.808-3.703-.949-11.488-.949h-9.02v21.836z"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "m530.199 456.501c-.096.095-.143 9.921-.049 21.837l.096 21.646h2.137 2.135v-21.837-21.835h-2.041c-1.14-.001-2.185.094-2.278.189z"
});

var SvgWalldorf = function SvgWalldorf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 286.445 595.281 222",
    viewBox: "0 286.445 595.281 222",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalldorf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "walldorf.svg";
export { ForwardRef as ReactComponent };